import {DynamicContent} from "pdfmake/interfaces";
import {formatDateWithTime} from "../consts";

export const defPDFFooter: DynamicContent = (currentPage, pageCount) => {
    return {
        fontSize: 12,
        color: '#838280',
        bold: true,
        alignment: 'justify',
        table: {
            widths: ['*', 'auto'],
            heights: 36,
            body: [
                [
                    {
                        borderColor: ['#838280', '#838280', '#838280', '#838280'],
                        border: [false, true, false, false],
                        margin: [20, 4, 0, 0],
                        text: `Документ сформирован ${JSON.parse(JSON.stringify(formatDateWithTime))}`,
                        alignment: 'left',
                        bold: true
                    },
                    {
                        borderColor: ['#838280', '#838280', '#838280', '#838280'],
                        border: [false, true, false, false],
                        margin: [0, 4, 20, 0],
                        alignment: 'right',
                        bold: true,
                        text: 'Лист ' + currentPage.toString() + ' из ' + pageCount
                    },
                ]
            ]
        }
    }
}
